import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
function isProductType(value) {
  return value === 'APP' || value === 'AGENT';
}
export function useProductTypeSearchParams() {
  const {
    getList
  } = useSearchParams();
  return getList('PRODUCT_TYPE').filter(isProductType);
}
export function useProductTypeSearchParam() {
  const productTypes = useProductTypeSearchParams();
  return productTypes.length === 1 ? productTypes[0] : undefined;
}